import { createI18n } from 'vue-i18n';
import { DEFAULT_LOCALE } from './locale.js';
import { en } from './messages/en.js';
import { fr } from './messages/fr.js';
export const messages = { fr, en };
export { errorMessageKey } from './errors.js';
export { clearFormatterCache, formatBytes, formatCompactNumber, formatDate, formatDateTime, formatMoment, formatNumber, formatPercent, formatRelativeTime, formatTime, formatWallClockDate, formatWallClockDateRange, localDayKey, wallClockDayKey, } from './formatters.js';
export { DEFAULT_LOCALE, SUPPORTED_LOCALES, detectLocale, isSupportedLocale, useLocale } from './locale.js';
export { useAsyncAction } from './useAsyncAction.js';
export { en, fr };
// Return type is inferred: vue-i18n's `I18n` generic takes five parameters
// whose exact shapes are internal, and naming them here only creates a second
// place to keep in sync with the library.
export function createAppI18n(locale = DEFAULT_LOCALE) {
    return createI18n({
        // Composition API mode. The Options API mode is deprecated and its `$t`
        // global is exactly the sort of implicit dependency that makes components
        // hard to test in isolation.
        legacy: false,
        globalInjection: true,
        locale,
        fallbackLocale: DEFAULT_LOCALE,
        messages,
        // A missing key is a bug we want to see in development, not a silent blank.
        missingWarn: true,
        fallbackWarn: false,
    });
}
//# sourceMappingURL=index.js.map